import { useDispatch, useSelector } from "react-redux";

import { message } from "antd";
import Button from "../../components/button";
import InputLabel from "../../components/inputLabel";
import PageTitle from "../../components/pageTitle";
import { RecuperacaoSenhaForm, RecuperacaoSenhaWrapper } from "./styled";
import recuperarSenhaActions from "../../redux/recuperarSenha/actions";
import { StoreState } from "../../redux/reduxTypes";
import { RecuperarSenhaState } from "../../types/state.types";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

function RecuperarSenha() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dados, dadosConfirmados, email } = useSelector<
    StoreState,
    RecuperarSenhaState
  >((state) => state.recuperarSenhaState);

  const confirmarDados = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (!dados.email || !dados.cpf || !dados.dataNascimento) {
        return message.warning("Favor preencher todos os dados");
      }
      dispatch(
        recuperarSenhaActions.confirmarDados(
          dados.email,
          dados.cpf,
          dados.dataNascimento
        )
      );
    },
    [dispatch, dados.email, dados.cpf, dados.dataNascimento]
  );

  const recadastrarSenha = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (
        !dados.email ||
        !dados.cpf ||
        !dados.dataNascimento ||
        !dados.novaSenha ||
        !dados.confNovaSenha ||
        !dados.codigo
      ) {
        return message.warning("Favor preencher todos os dados");
      }
      dispatch(
        recuperarSenhaActions.recastrarNovaSenha(
          dados.email,
          dados.cpf,
          dados.dataNascimento,
          dados.novaSenha,
          dados.confNovaSenha,
          dados.codigo,
          () => {
            message.success("Senha recuperada com sucesso!");
            navigate("/");
          }
        )
      );
    },
    [dispatch, dados, navigate]
  );

  const atualizarDados = useCallback(
    (novosDados: Object) => {
      dispatch(
        recuperarSenhaActions.setDados({
          ...dados,
          ...novosDados,
        })
      );
    },
    [dispatch, dados]
  );

  return (
    <RecuperacaoSenhaWrapper>
      <PageTitle titulo="Área Restrita - Recuperação de Senha" centralizado />

      <RecuperacaoSenhaForm
        onSubmit={dadosConfirmados ? recadastrarSenha : confirmarDados}
      >
        {!dadosConfirmados ? (
          <>
            <p>Enviaremos um código para seu e-mail cadastrado</p>
            <InputLabel
              labelText="E-mail"
              labelId="email"
              type="text"
              value={dados.email}
              onChange={(value) => {
                atualizarDados({
                  email: value,
                });
              }}
              required
              column
            />

            <InputLabel
              labelText="CPF"
              labelId="cpf"
              type="number"
              value={dados.cpf}
              onChange={(value) => {
                atualizarDados({
                  cpf: value,
                });
              }}
              required
              column
            />

            <InputLabel
              labelText="Data de Nascimento"
              labelId="dataNascimento"
              type="date"
              value={dados.dataNascimento}
              onChange={(value) => {
                atualizarDados({
                  dataNascimento: value,
                });
              }}
              required
              column
            />
          </>
        ) : (
          <>
            <p>Verifique o código no e-mail {email}</p>
            <InputLabel
              labelText="Código de Confirmação"
              labelId="codigo"
              type="text"
              value={dados.codigo}
              onChange={(value) => {
                atualizarDados({
                  codigo: value,
                });
              }}
              required
              column
            />

            <InputLabel
              labelText="Nova Senha"
              labelId="novaSenha"
              type="password"
              value={dados.novaSenha}
              onChange={(value) => {
                atualizarDados({
                  novaSenha: value,
                });
              }}
              required
              column
            />

            <InputLabel
              labelText="Repetir Senha"
              labelId="confNovaSenha"
              type="password"
              value={dados.confNovaSenha}
              onChange={(value) => {
                atualizarDados({
                  confNovaSenha: value,
                });
              }}
              required
              column
            />
          </>
        )}

        <Button primary type="submit">
          {dadosConfirmados ? "Alterar Senha" : "Continuar"}
        </Button>
      </RecuperacaoSenhaForm>
    </RecuperacaoSenhaWrapper>
  );
}

export default RecuperarSenha;
